/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  WebUserFeedbackPageType,
  webUserFeedbackPageTypeFromJSON,
  webUserFeedbackPageTypeToJSON,
} from "./Common/WebUserFeedbackPageType";
import {
  WebUserFeedbackSubmitType,
  webUserFeedbackSubmitTypeFromJSON,
  webUserFeedbackSubmitTypeToJSON,
} from "./Common/WebUserFeedbackSubmitType";

export const protobufPackage = "Reality.Reality.Api";

export interface WebUserFeedbackStatusGetRequest {
  pageType: WebUserFeedbackPageType;
  pageId: string;
}

export interface WebUserFeedbackStatusGetResponse {
  submitType: WebUserFeedbackSubmitType;
}

function createBaseWebUserFeedbackStatusGetRequest(): WebUserFeedbackStatusGetRequest {
  return { pageType: 0, pageId: "" };
}

export const WebUserFeedbackStatusGetRequest = {
  encode(message: WebUserFeedbackStatusGetRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pageType !== 0) {
      writer.uint32(8).int32(message.pageType);
    }
    if (message.pageId !== "") {
      writer.uint32(18).string(message.pageId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebUserFeedbackStatusGetRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebUserFeedbackStatusGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.pageType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pageId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebUserFeedbackStatusGetRequest {
    return {
      pageType: isSet(object.pageType) ? webUserFeedbackPageTypeFromJSON(object.pageType) : 0,
      pageId: isSet(object.pageId) ? globalThis.String(object.pageId) : "",
    };
  },

  toJSON(message: WebUserFeedbackStatusGetRequest): unknown {
    const obj: any = {};
    if (message.pageType !== 0) {
      obj.pageType = webUserFeedbackPageTypeToJSON(message.pageType);
    }
    if (message.pageId !== "") {
      obj.pageId = message.pageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebUserFeedbackStatusGetRequest>, I>>(base?: I): WebUserFeedbackStatusGetRequest {
    return WebUserFeedbackStatusGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebUserFeedbackStatusGetRequest>, I>>(
    object: I,
  ): WebUserFeedbackStatusGetRequest {
    const message = createBaseWebUserFeedbackStatusGetRequest();
    message.pageType = object.pageType ?? 0;
    message.pageId = object.pageId ?? "";
    return message;
  },
};

function createBaseWebUserFeedbackStatusGetResponse(): WebUserFeedbackStatusGetResponse {
  return { submitType: 0 };
}

export const WebUserFeedbackStatusGetResponse = {
  encode(message: WebUserFeedbackStatusGetResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.submitType !== 0) {
      writer.uint32(8).int32(message.submitType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WebUserFeedbackStatusGetResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebUserFeedbackStatusGetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.submitType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebUserFeedbackStatusGetResponse {
    return { submitType: isSet(object.submitType) ? webUserFeedbackSubmitTypeFromJSON(object.submitType) : 0 };
  },

  toJSON(message: WebUserFeedbackStatusGetResponse): unknown {
    const obj: any = {};
    if (message.submitType !== 0) {
      obj.submitType = webUserFeedbackSubmitTypeToJSON(message.submitType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebUserFeedbackStatusGetResponse>, I>>(
    base?: I,
  ): WebUserFeedbackStatusGetResponse {
    return WebUserFeedbackStatusGetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebUserFeedbackStatusGetResponse>, I>>(
    object: I,
  ): WebUserFeedbackStatusGetResponse {
    const message = createBaseWebUserFeedbackStatusGetResponse();
    message.submitType = object.submitType ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
